import script from "./AdminFormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormHeader.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormHeader.vue?vue&type=style&index=0&id=5655adf2&lang=scss&scope=true"

const __exports__ = script;

export default __exports__